import React, { FunctionComponent } from 'react'
import { ArrowForwardIos } from '@mui/icons-material'
import { Help } from '@/services/cms-api/home-page-content/types'
import { useLanguage } from '@/context/LanguageContext'
import Image from 'next/image'
import Link from 'next/link'
import useIntl from '@/utils/intl'
import { IMG_URL } from '@/utils/constants'
import MCButton from '@/components/ui/Buttons/MobicomButton'

interface Prop {
  helps: Help[]
}
const HelpSection: FunctionComponent<Prop> = ({ helps }) => {
  const { locale } = useLanguage()
  const { translate } = useIntl()
  if (helps === undefined || helps === null) {
    return <></>
  }
  return (
    <div id='help' className='lg:py-16 py-6'>
      <div className='flex flex-col lg:flex-row px-6 py-14 items-center xl:gap-24 gap-12 justify-center'>
        <div className='flex flex-col lg:w-1/4'>
          <span className='xl:text-5xl text-3xl text-textHigh font-extrabold lg:text-left text-center mt-3'>{translate('help.title')}</span>
          <div className='p-2 border rounded-xl mt-5'>
            <Link href='https://aibot.mobicom.mn/' rel='noopener noreferrer' target='_blank'>
              <MCButton size='sm' fullwidth>{translate('chatGPT_button')}</MCButton>
            </Link>
            <div className='flex w-full justify-center items-center gap-1 mt-3'>
              <Image draggable={false} width={1000} height={1000} className='h-6' src='/icons/gpt.svg' alt='img' />
            </div>
          </div>
          {/* Танд <span className='text-[#F87171]'>тусламж</span> хэрэгтэй юу? */}
        </div>
        <div className='lg:relative flex justify-center'>
          <Image draggable={false} width={1000} height={1000} className='rounded-xl w-full h-full lg:absolute object-cover hidden lg:flex aspect-square' src={IMG_URL + '/uploads/helpBg.png'} alt='img' />
          <div className='hidden lg:grid grid-cols-2 gap-6 absolute lg:relative px-8 lg:px-0'>
            {helps.map((item: Help, i: number) => (
              <Link id={item.titleEn.toLowerCase().split(' ').join('_')} key={i} href={item.link ?? ''} rel='noopener noreferrer' target='_blank'>
                <div key={i} className={'p-6 bg-surfaceInverse85 border border-bordersm rounded-2xl xl:w-96 lg:w-80 col-span-1 hover:border-hover hover:bg-surfaceInverse cursor-pointer ' + (i % 2 === 0 ? 'relative top-16' : '')}>
                  <div className='flex justify-center items-center w-14 h-14 p-3 bg-[#FEF2F2] rounded-full border shadow-[inset_0_0_4px_0_rgba(248,113,113,1)]'>
                    <Image draggable={false} src={IMG_URL + item.icon} alt='?' width={16} height={16} className='w-9' />
                  </div>
                  <h1 className='mt-3 text-xl font-bold text-textHigh'>{locale === 'en' ? item.titleEn : item.titleMn}</h1>
                  <div className='mt-2 flex items-center'>
                    <p className='text-xs font-medium text-textMid'>{locale === 'en' ? item.descriptionEn : item.descriptionMn}</p>
                    <ArrowForwardIos className='text-textMid text-sm' />
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className='flex gap-3 overflow-x-scroll scrollbar-thin lg:hidden w-[95vw] h-full'>
            {helps.map((item: Help, i: number) => (
              <Link key={i} href={item.link ?? ''} rel='noopener noreferrer' target='_blank'>
                <div className='p-6 bg-surfaceWebGrey/80 border border-bordersm rounded-2xl hover:border-hover hover:bg-surfaceInverse cursor-pointer w-[278px] h-full'>
                  <div className='flex justify-center items-center w-14 p-3 bg-[#FEF2F2] rounded-full border shadow-[inset_0_0_4px_0_rgba(248,113,113,1)]'>
                    <Image draggable={false} src={IMG_URL + item.icon} alt='?' width={16} height={16} className='w-9' />
                  </div>
                  <div className='w-[246px]'>
                    <h1 className='mt-3 text-xl font-bold text-textHigh'>{locale === 'en' ? item.titleEn : item.titleMn}</h1>
                    <div className='mt-2 flex items-center'>
                      <p className='text-medium text-xs font-medium text-textMid'>{locale === 'en' ? item.descriptionEn : item.descriptionMn}</p>
                      <ArrowForwardIos className='text-medium text-sm' />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

        </div>

      </div>
    </div>
  )
}
export default HelpSection
